import React from "react"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"

interface GlowBoxProps {
  className?: string
}

const GlowBox = ({ className }: GlowBoxProps) => {
  return (
    <Wrapper>
      <Glow className={className}>
        <div className="box">
          <div className="glowLeft"></div>
        </div>
        <div className="box">
          <div className="glowRight"></div>
        </div>
        <div className="box">
          <div className="glowCenter"></div>
        </div>
      </Glow>
    </Wrapper>
  )
}

export default GlowBox

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -2;
  @media (max-width: 480px) {
    /* display: none; */
  }
`

const Glow = styled.div`
  width: 100%;
  height: 100%;
  cursor: none;
  position: relative;
  pointer-events: none;
  z-index: -1;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    backdrop-filter: blur(60px);
    z-index: -1;
  }
  .box {
    --size: 30vw;
    --time: 12s;
    position: absolute;
    width: var(--size);
    height: var(--size);
    z-index: -1;
    will-change: transform;

    top: calc(50% - var(--size) / 2);
    left: calc(50% - var(--size) / 2);
    animation: spin var(--time) infinite linear;
    /* background-color: #fff; */
    &:nth-child(1) {
      animation-delay: calc(var(--time) / 3 * -1);
    }
    &:nth-child(2) {
      animation-delay: calc(var(--time) / 3 * -2);
    }
    @media (max-width: 480px) {
      width: calc(var(--size) * 2);
      height: calc(var(--size) * 2);
      top: calc(50% - var(--size) * 2);
      left: calc(50% - var(--size));
      /* animation: none; */
    }

    div {
      width: 100%;
      height: 100%;
      border-radius: 45%;
      transform: translate(20%, 0);
      opacity: 0.3333;
    }

    .glowLeft {
      will-change: transform;
      background: linear-gradient(
        270deg,
        ${themeGet("colors.primary")},
        ${themeGet("colors.primary")}
      );
      animation: animateGlow 36s linear infinite;
      @media (max-width: 480px) {
        animation: none;
      }
    }
    .glowRight {
      will-change: transform;
      background: linear-gradient(120deg, #f0aeffd3, #df66fa);
      animation: animateGlow 36s linear infinite -0s;
      @media (max-width: 480px) {
        animation: none;
      }
    }
    .glowCenter {
      will-change: transform;
      background: linear-gradient(270deg, #9ac1f8, #1267e0);
      animation: animateGlow 36s linear infinite -0s;
      @media (max-width: 480px) {
        animation: none;
      }
    }
  }
  @keyframes animateGlow {
    15% {
      transform: scale(1.5) translate(30%, 0) rotate(180deg);
      opacity: 0.1;
    }
    50% {
      transform: scale(2) translate(80%, 0) rotate(360deg);
    }
    85% {
      transform: scale(1.5) translate(30%, 0) rotate(180deg);
      opacity: 0.1;
    }
  }
`
